import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { RGBAFormat } from "three";

gsap.registerPlugin(ScrollTrigger, SplitText);

import Sketch from './app.js';

let animation = new Sketch({
  dom: document.getElementById("container")
});

gsap.to(animation.settings,{
    duration: 3,
    progress: 1,
    ease: "expo.inOut"
})

let container = document.getElementById('wrapper')
let o = {
    pr:2
}
gsap.to(o,{
    pr: 3,
    ease: "sine.inOut",
    scrollTrigger: {
        trigger: '#container',
        pin: true,
        scrub: 0.2,
        onUpdate: (self)=>{
            gsap.set(container,{
                x: self.progress*-(container.scrollWidth - document.documentElement.clientWidth)+"px"
            })
        }
    }
})

function raf(){
    animation.material.uniforms.time.value = -o.pr*50.;
    window.requestAnimationFrame(raf);
}
raf()


  